import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Button } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Docmnt from '../../../../assets/images/google-docs.png';
import Export from "../../../../assets/images/export.svg";
import Rapdf from "../../../../assets/images/pdf.png";
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { withRFSToken } from "../../../../Services/axios"; 


import { Tab, Tabs } from 'react-bootstrap';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions';

const Delivered = () => {

  const isMounted = useRef(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const [resetFilter, setResetFilter] = useState(false);
  const gridRef = useRef(null);
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    isMounted.current = true;
  }, []);


  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);


  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }
  const handleDropdownItemClick = () => {

  }

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRef?.current) {
      // if (gridData[activeTab]) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'release_number', type: 'string' },
          { name: 'record_id', type: 'string' },
          { name: 'house_awb', type: 'string' },
          { name: 'master_awb', type: 'string' },
          { name: 'take_in', type: 'string',},
          { name: 'take_out', type: 'string',},
          { name: 'acceptance', type: 'string' },
          { name: 'expected_pcs', type: 'string' },
          { name: 'expected_weight', type: 'string' },
          { name: 'accepted_pcs', type: 'string' },
          { name: 'pcs_stock', type: 'string' },
          { name: 'pieces_picked', type: 'string' },
          { name: 'consolidate_pdf', type: 'string' },
          { name: 'trucking_company', type: 'string' },
          { name: 'release', type: 'string' },
          { name: 'delivery_pdf', type: 'string' },
          { name: 'delivery_status', type: 'string' },
          { name: 'delivery_pcs', type: 'string' },
          { name: 'import_shipment_record_id', type: 'string' },
          { name: 'is_invoice', type: 'string' },
          { name: 'invoice_amount', type: 'string' },
          { name: 'invoice_currency', type: 'string' },
          { name: 'delivered_to', type: 'string' },
          { name: 'customer_name', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}shipment/delivered`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRef.current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRef.current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        // { text: 'Release Number', filtertype: 'input', datafield: 'release_number', width: '6%', cellclassname: '', },
        { text: 'Shipment ID', filterable: 'input', datafield: 'record_id', width: '8%', cellclassname: '', },
        { text: 'Master AWB', filterable: 'input', datafield: 'master_awb', width: '6%', cellclassname: '', },
        {
            text: "Invoiced", datafield: "is_invoice", width: "5%",
            filtertype: 'checkedlist',
            filteritems: [
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
            ],
            cellclassname: (row, column, value, rowData, cellvalue) => {
              // console.log("🚀 ~ useEffect ~ rowData:", rowData)
              if (rowData.is_invoice == "No") {
                return "awb_orange";
              } else if (rowData.is_invoice == "Yes") {
                return "awb_green";
              } else {
                return;
              }
            },
          },{ text: 'Currency', filtertype: 'input', datafield: 'invoice_currency', width: '5%', cellclassname: '', },
          
          { text: 'TTL Amount', filtertype: 'input', datafield: 'invoice_amount', width: '6%', cellclassname: '', },
        { text: 'House AWB', filtertype: 'input', datafield: 'house_awb', width: '6%', cellclassname: '', },
        { text: 'Take In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_in', width: '8%', cellclassname: '', },
        { text: 'Take Out', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_out', width: '8%', cellclassname: '', },
        // {
        //   text: 'Acceptance', filterable: false, datafield: 'acceptance', width: '8%', cellclassname: '',
        //   cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
        //     if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
        //       defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
        //     }
        //     return (
        //       defaultHtml
        //     );
        //   },
        // },
        { text: 'Exp Pcs', filtertype: 'input', datafield: 'expected_pcs', width: '4%', cellclassname: '', },
        { text: 'Exp Weight', filtertype: 'input', datafield: 'expected_weight', width: '6%', cellclassname: '', },
        { text: 'Accepted Pcs', filterable: false, datafield: 'accepted_pcs', width: '6%', cellclassname: '', },
        { text: 'Stock', filtertype: 'input', datafield: 'pcs_stock', width: '4%', cellclassname: '', },
        { text: 'Picked', filtertype: 'input', datafield: 'pieces_picked', width: '4%', cellclassname: '', },
        { text: 'Delivery', filtertype: 'input', datafield: 'delivery_pcs', width: '4%', cellclassname: '', },
        // {
        //   text: 'Consolidate Pdf', filterable: false, datafield: 'consolidate_pdf', width: '8%', cellclassname: '',
        //   cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
        //     if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
        //       defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
        //     }
        //     return (
        //       defaultHtml
        //     );
        //   },
        // },
        // { text: 'Trucking Company', filtertype: 'textbox', datafield: 'trucking_company', width: '8%', cellclassname: '', },
        // { text: 'Delivered to', filtertype: 'textbox', datafield: 'delivered_to', width: '7%', cellclassname: '', },
        {
          text: 'Delivery Receipt', filterable: false, datafield: 'delivery_pdf', width: '6%', cellclassname: '',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        { text: 'Customer', filtertype: 'input', datafield: 'customer_name', width: '7%', cellclassname: '', },
        {
          text: 'Delivery Status', filtertype: 'input', datafield: 'delivery_status', width: '8%', cellclassname: '',
        },
        // {
        //   text: 'Release', filtertype: 'checkedlist', datafield: 'release', width: '8%',
        //   filteritems: [
        //     { label: 'Open', value: 'Open' },
        //     { label: 'Progress', value: 'Progress' },
        //     { label: 'Complete', value: 'Complete' },
        //     { label: 'Incomplete', value: 'Incomplete' },
        //   ],
        //   cellclassname: (row, column, value, rowData, cellvalue) => {
        //     // console.log("🚀 ~ useEffect ~ rowData:", rowData)
        //     if (rowData.release == 'Completed') {
        //       return "awb_green";
        //     } else if (rowData.release == 'Incomplete') {
        //       return "awb_red";
        //     } else if (rowData.release == 'Progress') {
        //       return "awb_orange";
        //     } else if (rowData.release == 'Open') {
        //       return "awb_blue";
        //     } else if (rowData.release == 'Initiated') {
        //       return "awb_sky";
        //     } else {
        //       return;
        //     }
        //   },
        // },
        // {
        //   text: 'Actions',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
        //   },
        //   width: '5%', filterable: false,
        // },
        // { text: 'Shipment Number', filtertype: 'textbox', datafield: 'shipment_number', width: '12%', cellclassname: '', },
        // { text: 'Take In', filtertype: 'textbox', datafield: 'take_in', width: '12%', cellclassname: '', },
        // { text: ' ', filterable: false, width: '6%', cellclassname: '', },
        // {
        //   text: 'Screened', filtertype: 'textbox',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><span class="screen">No</span></div>';
        //   }, width: '8%', cellclassname: '',
        // },
        // { text: 'TTL Pieces', filtertype: 'textbox', datafield: 'ttl_pcs', width: '8%', cellclassname: '', },
        // { text: 'TTL Weight', filtertype: 'textbox', datafield: 'ttl_weight', width: '8%', cellclassname: '', },
        // { text: 'Location', filtertype: 'textbox', datafield: 'location', width: '8%', cellclassname: '', },
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: '',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        // rendered: function () {
        //   const rows = window.$(gridRef.current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRef.current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRef.current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const dataToSend = {
          uld_number: rowData.uld_number,
          type_code: rowData.type_code,
          serial_number: rowData.serial_number,
          owner_code: rowData.owner_code,
          condition_code: rowData.condition_code,
          asset_type: rowData.asset_type == 'Y' ? false : true
        };
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRef.current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        console.log("🚀 ~ rowData:", rowData)
        setIsModal(true)
      });
      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRef.current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.uld_number;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // console.log(checkUlds);
          // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRef.current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.uld_number;
          setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
          // if(filterForCheck!=true){
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
          // }
          // console.log(checkUlds);

        }
      });
      window.$(gridRef.current).off('cellclick');
      window.$(gridRef.current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (![14].includes(event.args.columnindex)) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          // loadDetails(args.uld_number);
          loadHawbDetails(args);
          //setSelectedRowData(args)
          setTimeout(() => {
            window.$(gridRef.current).jqxGrid('refresh');
          }, 30);
        }
      });
      // }
    }
  }, [gridData]);

  const loadHawbDetails = async (localData) => {
      // console.log("🚀 ~ loadHawbDetails ~ localData:", localData)
      try {
  
        const res = await withRFSToken.post('shipment/get-movement-log', { shipment_record_id: [localData.import_shipment_record_id], type: 'delivered' })
          .then(function (res) {
            const innerData = res.data.response_data;
            const transData = { ...localData, mvtLog: innerData }
            setSelectedRowData(transData);
            // setSubMawb(true);
            // setTimeout(() => {
            //   window.$(gridRefs[activeTab].current).jqxGrid("refresh"); 
            // }, 30);
          });
  
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

  const loadDetails = async (id) => {
    if (id == null) {
      toast.error("Old Data. Data not viewable.");
      return;
    }
    localStorage.removeItem('SHEdit');
    localStorage.setItem('SHEdit', JSON.stringify(id));
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
    localStorage.setItem('AddShipmentType', 'release');
    history.push('/ForwarderShipments/AddShipmentRecords');
  };
  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRef.current).jqxGrid('refresh');
    }, 30);
  };
  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  // const handleFileChange = (e) => {
  //     const selectedFiles = Array.from(e.target.files);
  //     const filesWithBase64 = [];
  //     selectedFiles.forEach((file) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             filesWithBase64.push({ file, base64: reader.result });
  //             if (filesWithBase64.length === selectedFiles.length) {
  //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

  //             }
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // }
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // +++++++++++++++++++++++++++++++++++ Silk Slider
  const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };



  const isModalClose = () => {
    setIsModal(false);
  }

  const resetFilters = () => {
    window.$(gridRef.current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };
  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Import');
    history.push('/ForwarderShipments/CreateCargo')
  }

  const handleDownload = async () => {
    try {
      const ids = gridSelect?.map(data => data.id) || [];

      const payload = {
        tab_name: 'Delivered',
        fields: '',
        ids: ids,
        status: ''
      };

      const res = await withRFSToken.post('shipment/download-import-shipment', payload, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Delivered_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Downloaded successfully');
      setGridSelect([]);
      window.$(gridRef.current).jqxGrid("clearselection");
      window.$(gridRef.current).jqxGrid("updatebounddata");
    } catch (error) {
      console.error('Error downloading data:', error);
      toast.error('Failed to download data');
    }
  };

  return (
    <>
      <div className="mb-3 nestedtabs rounded minh">
        <div className='d-flex'>
          <div className='ulddown'>
            <button onClick={handleDownload}>
                <img src={Export} alt="export" /> Download
            </button>
          </div>        </div>
      </div>
      <div className="maindiv">
        <div className='trashdonload position-relative'>
          {!isLoading &&<>
          {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
           <div ref={gridRef} className='bookinggrid' ></div></>}
        </div>
        {selectedRowData && (
          <div className='SecondDiv'>
            {/* {console.log('55', selectedRowData)} */}
            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
            <div className='girddtals_header'>
              <h3>
                {selectedRowData.release_number} &nbsp; <span>{selectedRowData.status}</span>
              </h3>
              <div className='d-flex actbtn justify-content-between'>
                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
               
                  <div className='viwall' onClick={() => loadDetails(selectedRowData?.import_shipment_record_id)}>
                    <Link to='#'>Details</Link>
                  </div>
                
              </div>

            </div>
            <div className='mt-3'>
              
              <div className='mb-3'>
                <h3>HAWB Information</h3>
                 {selectedRowData?.mvtLog?.map(log => (
                      <div className="hawb_pic_list">
                        <ul>
                          <li>
                            <p><span>Delivered Date : {log.moved_at.split(" ")[0]}</span> <span>Delivered Time : {log.moved_at.split(" ")[1]}</span> </p>
                          </li>
                          {/* <li>
                            <p><span>Delivery Receipt: <img src={Rapdf} style={{width: "20px" }} /> </span> </p>
                          </li> */}
                          <li>
                            {log.stage === 'in_stock' ?
                              <></>
                              :
                              <span >Pcs Picked : {log.picked_pcs}</span>
                            }
                            <span>{log.stage === 'in_stock' ? "Accepted Pcs" : "Delivered Pcs"} : {log.pieces_moved}</span>
                            <span>Stage : {log.stage}</span>
                            {log.import_delivery_pdf && (
                              <span>
                                Pdf :{" "}
                                <a
                                  href={log.import_delivery_pdf}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img src={Rapdf} alt="PDF" style={{ width: "25px" }} />
                                </a>
                              </span>
                            )}
                          </li>
                        </ul>
                      </div>
                    ))}
                <h3>Highlighted Image(s)</h3>
                {selectedRowData?.attachments && (
                  <div className='main_primary'>
                    {findPrimary.map((file, index) => {
                      const fileName = file?.file_name;
                      // console.log("🚀 ~ {files.map ~ file:", file)
                      const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                      const extension = fileName?.split(".").pop();
                      return (
                        <>
                          <div key={`ns_${index}`} className='primary_image'>
                            {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                            ) ? (
                              <div>
                                <img
                                  src={file.file_path}
                                  alt="Preview"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",

                                  }}
                                  // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                  onClick={() =>
                                    handleFileClick(file.file_path)
                                  }
                                />
                              </div>
                            ) : (
                              <>
                                <span className="">
                                  <img src={Docmnt} className="fileimg" />
                                </span>
                              </>
                            )}
                            <span className="rafilename">
                              {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"uld"}
              attachable_id={selectedRowData.uld_number}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
            />
            <ActivityComments
              commentable_type={"uld"}
              commentable_id={selectedRowData.uld_number}
              allactivities={selectedRowData.activities}
              onReloadDetails={loadDetails}
            />
          </div>
        )}
      </div>
      <Modal show={isModal} onHide={!isSaving ? isModalClose : null} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Confirm Screened</h3>
          <p>If you proceed with the change, user data will be removed. <br /> Are you sure you want to continue? </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" disabled={isSaving} className='position-relative'>
            {isSaving ? <>Update Screened<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Update Screened'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Delivered